
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { provideHttpClient, withInterceptors } from '@angular/common/http'
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes';
import { DatePipe } from '@angular/common';
import { provideAnimations } from '@angular/platform-browser/animations';
import { jwtInterceptor } from './app/_interceptors/jwt.interceptor';
import { errorInterceptor } from './app/_interceptors/error.interceptor';
import { MAT_PAGINATOR_DEFAULT_OPTIONS } from '@angular/material/paginator';


if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),
        provideRouter(routes),
        provideHttpClient(withInterceptors([jwtInterceptor, errorInterceptor])),
        DatePipe,
        provideAnimations(),
        { provide: MAT_PAGINATOR_DEFAULT_OPTIONS, useValue: { formFieldAppearance: 'fill' } }
    ]
}).catch(err => console.error(err));
